import { useLocation } from 'react-router-dom';

import type { CategoryType } from '@popularKeyword/common-types';

const searchParamsKeys = ['category', 'page', 'rising', 'type', 'date', 'total'] as const;

type SearchParams = {
  [key in (typeof searchParamsKeys)[number]]: key extends 'category'
    ? CategoryType
    : key extends 'rising'
    ? 'true' | 'false'
    : string;
};

const useSearchParams = (): SearchParams | object => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  return searchParamsKeys.reduce((totalParamObj, currentParamKey) => {
    totalParamObj[currentParamKey] = queryParams.get(currentParamKey);
    return totalParamObj;
  }, {});
};

export type { SearchParams };
export { useSearchParams };
